import store from "../../Store/configureStore";
import { strToFloat } from "../../Util/util";
const lodash = require("lodash");

export const getItVendorCost = () => {
  const state = store.getState();
  let softInstallCost = lodash.get(state, "costs.systemCostDetails.one-time-software-installation-cost");
  let annualFee = lodash.get(state, "costs.systemCostDetails.annual-fee");
  let years = lodash.get(state, "costs.costAdjustDetails.years-into-future");

  if (!softInstallCost) { softInstallCost = 0}
  if (!annualFee) { annualFee = 0}
  if (!years) { years = 0 }

  return strToFloat(softInstallCost) + ((strToFloat(annualFee) * strToFloat(years)));
};

export const getHourlyWagePlusBen = () => {
  const state = store.getState();
  let wage = lodash.get(state, "costs.systemCostDetails.wage-it-personnel");
  let benefit = lodash.get(state, "costs.systemCostDetails.hourly-benefit-amount");

  if (!wage) { wage = "0" }
  if (!benefit) { benefit = "0" }

  return strToFloat(wage) + strToFloat(benefit);
};

export const getItPersonnelCost = () => {
  const state = store.getState();
  const numberPersonnel = lodash.get(state, "costs.systemCostDetails.number-it-personnel");
  const wagePlusBen = getHourlyWagePlusBen();
  const retrainHours = lodash.get(state, "costs.systemCostDetails.retraining-hours");

  if (numberPersonnel && wagePlusBen && retrainHours) {
    return strToFloat(numberPersonnel) * strToFloat(wagePlusBen) * strToFloat(retrainHours);
  } else {
    return 0;
  }
};

export const getTotalSystemCost = () => {
  const state = store.getState();
  let itCost = getItVendorCost();
  let itPersonnelCost = getItPersonnelCost();
  let otherSystemCost = lodash.get(state, "costs.systemCostDetails.other-system-cost") || 0;

  if (!itCost) { itCost = 0 }
  if (!itPersonnelCost) { itPersonnelCost = 0 }
  if (!otherSystemCost) { otherSystemCost = 0 }

  return strToFloat(itCost) + strToFloat(itPersonnelCost) + strToFloat(otherSystemCost);
};
